import usePageTitle from 'utils/usePageTitle'
import { CannectCodeUI } from './CannectCodeUI'

export default function CannectCode() {
  usePageTitle('CANNECT Code — Teste Genético')

  return <CannectCodeUI />
}
